/* eslint-env es6 */

import ndAuthentication from 'authentication/nd.authentication';

export default ndAuthentication;
